<template>
  <FlexRow>
    <FlexColumn>
      <v-simple-table class="mt-3">
        <thead>
          <tr>
            <!-- BEレスポンスが想定された値にアプデされた時を想定したUIを、コメントoutしています -->
            <th width="50px" />
            <th width="160px">候補者</th>
            <!-- <th class="text-center" width="100px">温度感</th> -->
            <th width="480px">マッチングした求人</th>
            <th width="320px">メモ</th>
            <th width="90px">雇用形態</th>
            <th width="90px">
              <TextButton class="px-1" @click="handleChangeSort('lastAppliedAt')">
                <FlexRow align="center">
                  マッチ日
                  <v-icon v-if="sortedItem === 'lastAppliedAt' && sortedDirection === 'desc'">mdi-sort-descending</v-icon>
                  <v-icon v-if="sortedItem === 'lastAppliedAt' && sortedDirection === 'asc'">mdi-sort-ascending</v-icon>
                </FlexRow>
              </TextButton>
            </th>
            <th />
            <th width="180px" class="px-0">
              <TextButton class="px-1" @click="handleChangeSort('applicationStatus')">
                <FlexRow align="center">
                  ステータス
                  <v-icon v-if="sortedItem === 'applicationStatus' && sortedDirection === 'desc'">mdi-sort-descending</v-icon>
                  <v-icon v-if="sortedItem === 'applicationStatus' && sortedDirection === 'asc'">mdi-sort-ascending</v-icon>
                </FlexRow>
              </TextButton>
            </th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(user, index) of users" :key="index" style="height: 64px">
          <td>
            <SimpleCheckboxField
              :value="selectedMessage(user)"
              name=""
              hide-details
              :disabled="user.isUnsubscribed || isDeletedUser(user)"
              class="mt-0"
              @change="checked => handleSelectUser(user.message, checked)"
            />
          </td>
          <td class="">
            <div v-if="user.isDeleted" class="d-flex flex-column">
              <div class="d-flex align-center">
                {{ truncate(fullName(user), 20) }}
              </div>
              <div class="caption">{{label("deleted")}}</div>
            </div>

            <FlexColumn :space="0" style="gap: 4px">
              <Label v-if="!isDeletedUser(user)" :text="fullName(user)" />
              <!-- <Label :text="`${ fullName(user) }/${ user.age }/${ user.prefecture}`" /> -->

              <ApplicationTypeChip :via-request="user.viaRequest" :request-by-proxy="user.requestByProxy"/>
            </FlexColumn>
          </td>

          <!-- <td class="text-center body-2">今すぐ一緒に働きたい</td> -->

          <td>
            <router-link :to="`/clients/jobs/${user.job.id}`" class="link-text">
              <Label :text="user.job.name" />
            </router-link>
          </td>

          <td>
            <Label
              :text="user.memo || 'メモを記入'"
              size="body-2"
              no-of-lines="5"
              :style="{
                color: user.memo ? undefined : '#b3b3b3',
                wordBreak: 'break-all',
                backgroundColor: '#f7f7f7',
                padding: '0.3rem 0.5rem',
                borderRadius: '0.3rem',
                lineHeight: '1rem',
                height: '76px',
                cursor: 'pointer'
              }"
              @click="onClickMemo(user)"
            />
          </td>

          <td class="text-center">{{ user.job.isSide ? '業務委託' : '正社員' }}</td>

          <td class="text-center">
            <Label size="body-2" :text="dateToText(user.appliedAt)" />
          </td>


          <td class="text-center">
            <FlexRow align="center">
              <ApplicantDetailsButton
                  :user-id="user.id"
                  :target-job="user.job"
                  label="レジュメ閲覧"
                  label-size="body-2"
                  :primary="!user.isUnsubscribed && !isDeletedUser(user)"
                  small
                  :outlined="!user.isUnsubscribed && !isDeletedUser(user)"
                  :disabled="user.isUnsubscribed || isDeletedUser(user)"
              />
              <TextLink :to="`/clients/messages/${user.message}`" v-if="!user.isUnsubscribed && !isDeletedUser(user) && user.message">
                <Button
                    color="primary" small
                    @click="$router.push(`/clients/messages/${user.message}`)"
                >
                  <Label size="body-2" text="メッセージ" />
                </Button>
              </TextLink>
              <Button
                  v-else
                  color="primary" small
                  disabled
              >
                <Label size="body-2" text="メッセージ" />
              </Button>
            </FlexRow>
          </td>
          <td class="pl-0">
            <SelectField
                :value="user.applicationStatus"
                :items="candidateStatus(user.job)"
                :outlined="false"
                :disabled="isAcceptedOffer(user.applicationStatus) || user.isUnsubscribed || isDeletedUser(user)"
                simple dense
                class="py-0 mt-0 pl-1"
                style="flex: 0 0 190px"
                @change="value => changeCandidateStatus(user.job, user.id, value, index)"
            />
          </td>
        </tr>
        </tbody>
      </v-simple-table>

      <FlexRow class="mt-2" align="center">
        <Button color="primary" outlined @click="handleDownloadCsv">
          <Label v-if="selectedUsers.length === 0" text="すべての候補者情報をエクスポート"/>
          <Label v-else text="選択した候補者情報をエクスポート"/>
        </Button>
        <RadioField :items="encodes" v-model="encode" row />
      </FlexRow>
    </FlexColumn>

    <JoinDateFormDialog
        :open="showDialog"
        :userName="selectUserName"
        :jobId="selectJobId"
        :candidateId="selectCandidateId"
        :status="selectStatus"
        @complete="onCompleteJoinDateFormDialog"
        @cancel="onCancelJoinDateFormDialog"
    />
    <JoinSideJobFormDialog
        :open="showSideJobDialog"
        :userName="selectUserName"
        :jobId="selectJobId"
        :candidateId="selectCandidateId"
        :status="selectStatus"
        @complete="onCompleteJoinSideJobFormDialog"
        @cancel="onCancelJoinSideJobFormDialog"
    />
    <JoinCompleteDialog
        :open="compeleteDialog"
        :isSide="selectJobIsSide"
        @close="compeleteDialog = false"
    />
    <MemoEditDialog
      v-model="showMemoDialog"
      :user="selectedUser"
      @update="handleUpdateMemo"
      @save="handleSaveMemo"
    />
  </FlexRow>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import ApiMixin from "../../ApiMixin";
  import TextLink from "@/components/atoms/TextLink";
  import SelectField from "@/components/atoms/SelectField";
  import {mapGetters} from "vuex";
  import JoinDateFormDialog from "@/components/organisms/JoinDateFormDialog";
  import JoinCompleteDialog from "@/components/organisms/JoinCompleteDialog";
  import {jobApplicationStatus} from "@/enums";
  import JoinSideJobFormDialog from "@/components/organisms/JoinSideJobFormDialog";
  import FlexColumn from "../atoms/FlexColumn";
  import FlexRow from "../atoms/FlexRow";
  import Label from "../atoms/Label";
  import ApplicationTypeChip from "../molecules/ApplicationTypeChip";
  import Button from '../atoms/Button'
  import ApplicantDetailsButton from '../molecules/ApplicantDetailsButton'
  import TextButton from "../atoms/TextButton";
  import SimpleCheckboxField from "../atoms/SimpleCheckboxField";
  import moment from "moment";
  import RadioField from "../atoms/RadioField";
  import MemoEditDialog from "@/components/organisms/MemoEditDialog.vue";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "organism",
    name: "JobUserList",
    props: {
      users: {
        type: Array,
        required: true
      },
      showStatusChip: Boolean
    },
    components: {
      MemoEditDialog,
      RadioField,
      SimpleCheckboxField,
      TextButton,
      ApplicantDetailsButton,
      Button,
      ApplicationTypeChip,
      Label,
      FlexRow,
      FlexColumn,
      JoinSideJobFormDialog,
      JoinCompleteDialog,
      JoinDateFormDialog,
      TextLink,
      SelectField,
    },
    data () {
      return {
        showDialog: false,
        showSideJobDialog: false,
        compeleteDialog: false,
        previousStatus: null,
        selectUserName: null,
        selectJobId: null,
        selectJobIsSide: false,
        selectCandidateId: null,
        selectStatus: null,
        sortedItem: "lastAppliedAt",
        sortedDirection: "desc",
        selectedUsers: [],
        encode: {select:"utf8"},

        // 新規追加(被っているものがあるかも)
        showMemoDialog: false,
        selectedUser: null,
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      ...mapGetters("client", ["company"]),
      candidateStatus() {
        return (job) => {
          if (this.regular(job)) {
            return jobApplicationStatus.regular
          }
          return jobApplicationStatus.side
        }
      },
      isAcceptedOffer () {
        return (status) => {
          return status === jobApplicationStatus.regular.find(ele => ele.label === "内定承諾").value
        }
      },
      regular() {
        return (job) => job.isSide === false
      },
      selectedMessage() {
        return (user) => {
          return this.selectedUsers.includes(user.message)
        }
      },
      encodes() {
        return [
          {label: "UTF-8", value: "utf8"},
          {label: "Shift JIS", value: "sjis"},
        ]
      }
    },
    methods: {
      fullName (user) {
        const lastName = user.lastName || "";
        const firstName = user.firstName || "";
        return lastName + " " + firstName;
      },
      changeCandidateStatus (job, candidateId, status, index){
        const user = this.users[index]
        if( this.isAcceptedOffer(status) ) {
          this.selectUserName = this.fullName(user)
          this.selectJobId = job.id
          this.selectJobIsSide = job.isSide
          this.selectCandidateId = candidateId
          this.selectStatus = status
          if (this.regular(job)) {
            this.showDialog = true
          } else {
            this.showSideJobDialog = true
          }
        } else if (![0, 1].includes(user.applicationStatus) && status === 6 ) {
          this.go(`/clients/messages/${user.message}?status=6`)
        } else {
          this.applyJobForClient(job.id, candidateId, status)
        }
        user.applicationStatus = status
      },
      onCompleteJoinDateFormDialog() {
        this.showDialog = false
        this.compeleteDialog = true
      },
      onCancelJoinDateFormDialog() {
        this.$emit("init")
        this.showDialog = false
      },
      onCompleteJoinSideJobFormDialog() {
        this.showSideJobDialog = false
        this.compeleteDialog = true
      },
      onCancelJoinSideJobFormDialog() {
        this.$emit("init")
        this.showSideJobDialog = false
      },
      handleChangeSort(value) {
        if (this.sortedItem === value) {
          this.sortedDirection = this.sortedDirection === 'desc' ? 'asc' : 'desc'
        } else {
          this.sortedItem = value
          this.sortedDirection = 'desc'
        }
        this.$emit("sort", this.sortedItem, this.sortedDirection)
      },
      handleSelectUser(messageId, checked) {
        if (checked) {
          this.selectedUsers.push(messageId)
        } else {
          this.selectedUsers = this.selectedUsers.filter(item => item !== messageId)
        }
      },
      handleDownloadCsv() {
        const date = moment().format("YYYYMMDDhhmmss")
        this.downloadCandidateUserCsv(this.company.id, this.selectedUsers, `candidates_${date}.csv`, this.encode.select)
      },
      isDeletedUser(user) {
        // 削除済みユーザーはメッセージが削除されるため、メッセージがnullの場合は削除済みユーザーと判定
        return user.message === null;
      },

      onClickMemo(user) {
        this.selectedUser = user
        this.showMemoDialog = true
      },
      async handleUpdateMemo(memo) {
        await this.saveMemoForClient(this.selectedUser.job.id, this.selectedUser.id, memo)
        this.showMemoDialog = false
      },
    },
    watch: {
      users: {
        handler() {
          this.selectedUsers.splice(0)
        }
      }
    }
  }
</script>

<style scoped>
td {
  padding: 8px 12px;
}

.link-text {
  color: black;
  transition: 0.2s;
}
.link-text:hover {
  color: rgba(0, 0, 0, .6);
  transition: 0.2s;
}
</style>
